<layout-block-list-outlet preContent
                          [attr.aria-label]="'CATALOG.PRECONTENT.LABEL'|translate"
                          [list]="page?.gridContentPre"
                          *ngIf="page._meta.alias === 'catalogPage'"></layout-block-list-outlet>
<app-catalog-search *ngIf="page._meta.alias === 'searchPage'"></app-catalog-search>
<app-catalog-search-layout [tags]="page.filters"
                           [banners]="banners"
                           [result]="result$ | async"
                           >
</app-catalog-search-layout>
<layout-block-list-outlet postContent
                          [attr.aria-label]="'CATALOG.POSTCONTENT.LABEL'|translate"
                          [list]="page?.gridContentPost"></layout-block-list-outlet>
